import { useReconciliationServiceIntegrationEnabled } from '@/context/services/invoice/ReceivedInvoice.service';
import { useReconciliationServiceIntegrationBeta2Flag } from '@/hooks/feature_flag/useReconciliationServiceIntegrationBeta2Flag';

/**
 * 突合サービス連携 is shown only when both gates are open: the feature flag is the
 * FE-side rollout kill-switch, `is_enabled` is the office's own setting. Keeping
 * both checks in one place means turning the flag off hides the feature
 * everywhere, and the post-rollout cleanup is a one-line change here.
 */
export const useReconciliationStatusVisible = (): boolean => {
  const isRolledOut = useReconciliationServiceIntegrationBeta2Flag();
  const isEnabledForOffice = useReconciliationServiceIntegrationEnabled();

  return isRolledOut && isEnabledForOffice;
};
